var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllustrationConstructions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 130,
    viewBox: "0 0 140 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3216 9.13519C26.308 9.13519 23.0537 12.2938 23.0537 16.1901L18 124.607C18 128.503 21.2543 131.661 25.268 131.661H146.731C150.746 131.661 154 128.503 154 124.607L147.5 0.161377C147.5 -3.73492 144.246 -6.89356 140.231 -6.89356L30.3216 9.13519Z",
    fill: "#F0F2F1"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M106 141.661L111.781 119.039L143.604 118.661L146 141.661",
    fill: "#006B3F"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4534 40.6614C86.5994 39.7599 85.812 38.7925 85.0978 37.7675C84.6505 37.1725 84.2658 36.5292 83.9502 35.8488C83.6552 35.1367 83.4178 34.4001 83.2405 33.6469L82.0174 29.0073C81.9942 28.8932 81.9942 28.7754 82.0174 28.6613C82.0379 28.5191 82.1044 28.3884 82.2061 28.2911C82.3078 28.1938 82.4383 28.1358 82.5761 28.1265C82.8608 28.1093 83.1427 28.1924 83.3764 28.3625C84.0776 28.8847 84.6053 29.6212 84.8864 30.4699C85.2035 31.2721 85.6112 34.0715 86.9702 33.1436C87.175 32.9849 87.3378 32.7747 87.4434 32.5327C87.5491 32.2906 87.5941 32.0247 87.5742 31.7596C87.5586 31.1343 87.3158 30.5385 86.8947 30.0925C86.2907 29.4634 85.3847 29.2117 84.826 28.5197C84.5468 28.1467 84.3952 27.6873 84.3952 27.2144C84.3952 26.7414 84.5468 26.282 84.826 25.909C84.5552 25.4397 84.4302 24.8947 84.4681 24.3485C84.5059 23.8024 84.7047 23.2818 85.0374 22.8578C84.7397 22.6411 84.5269 22.3199 84.4382 21.953C84.3494 21.5861 84.3906 21.1982 84.5542 20.8604C84.723 20.5291 84.9691 20.2473 85.27 20.0412C85.5708 19.835 85.9167 19.7111 86.2756 19.6809C89.507 19.3349 91.5002 23.6757 92.4666 26.2235C93.1915 28.8234 94.3912 31.2531 96 33.3795",
    fill: "#C1813E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132 71.648L106.022 49.2972L95.7776 30.6614L84 41.3191L99.3355 64.3094C100.347 65.8378 101.576 67.2123 102.985 68.3898L117.6 80.6614",
    fill: "#079D56"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.054 76.9942L112.177 78.6614L106 49.6614L129 69.1018",
    fill: "#079D56"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0396 -2.05473L84.9034 42.4298L84.7068 113.415V129.824C84.7395 130.115 84.8772 130.384 85.0934 130.579C85.3096 130.774 85.5892 130.882 85.879 130.882C86.1689 130.882 86.4485 130.774 86.6647 130.579C86.8809 130.384 87.0185 130.115 87.0513 129.824L87.1269 85.4156L87.3387 14.4301L87.3841 -2.05473C87.3513 -2.34585 87.2137 -2.61459 86.9975 -2.80971C86.7813 -3.00483 86.5016 -3.11267 86.2118 -3.11267C85.922 -3.11267 85.6423 -3.00483 85.4261 -2.80971C85.2099 -2.61459 85.0723 -2.34585 85.0396 -2.05473Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7836 -2.13071L57.6626 42.3538L57.4508 113.339V129.748C57.4508 130.064 57.5751 130.367 57.7964 130.591C58.0176 130.815 58.3177 130.94 58.6306 130.94C58.9435 130.94 59.2436 130.815 59.4649 130.591C59.6861 130.367 59.8104 130.064 59.8104 129.748L59.9314 85.2632L60.1432 14.2776V-2.13071C60.1432 -2.44705 60.0189 -2.75044 59.7976 -2.97413C59.5764 -3.19782 59.2763 -3.32349 58.9634 -3.32349C58.6505 -3.32349 58.3504 -3.19782 58.1291 -2.97413C57.9079 -2.75044 57.7836 -2.44705 57.7836 -2.13071Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5116 8.68051L30.4058 45.9778L30.2394 105.097V118.783C30.2394 119.099 30.3637 119.403 30.5849 119.627C30.8062 119.85 31.1063 119.976 31.4192 119.976C31.7321 119.976 32.0322 119.85 32.2534 119.627C32.4747 119.403 32.599 119.099 32.599 118.783L32.7049 81.4705L32.8713 22.3516V8.68051C32.8713 8.36417 32.747 8.06078 32.5257 7.83709C32.3044 7.6134 32.0044 7.48773 31.6915 7.48773C31.3785 7.48773 31.0785 7.6134 30.8572 7.83709C30.6359 8.06078 30.5116 8.36417 30.5116 8.68051Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.236 13.3605L111.979 101.947V114.578C112.012 114.87 112.149 115.138 112.365 115.333C112.582 115.528 112.861 115.636 113.151 115.636C113.441 115.636 113.72 115.528 113.937 115.333C114.153 115.138 114.29 114.87 114.323 114.578L114.58 25.9764V13.3605C114.548 13.0694 114.41 12.8006 114.194 12.6055C113.978 12.4104 113.698 12.3026 113.408 12.3026C113.118 12.3026 112.839 12.4104 112.622 12.6055C112.406 12.8006 112.269 13.0694 112.236 13.3605Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15386 33.8818L53.2605 34.0194L123.641 34.2182H139.901C140.214 34.2182 140.514 34.0925 140.735 33.8688C140.956 33.6451 141.081 33.3418 141.081 33.0254C141.081 32.7091 140.956 32.4057 140.735 32.182C140.514 31.9583 140.214 31.8326 139.901 31.8326L95.7941 31.7103L25.414 31.5574H9.15386C8.8659 31.5905 8.60008 31.7296 8.40709 31.9482C8.21409 32.1668 8.10742 32.4495 8.10742 32.7425C8.10742 33.0355 8.21409 33.3182 8.40709 33.5368C8.60008 33.7554 8.8659 33.8945 9.15386 33.9276V33.8818Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.985932 83.6419L38.044 83.749L97.1705 83.8866H110.784C111.072 83.8535 111.337 83.7144 111.53 83.4958C111.723 83.2772 111.83 82.9945 111.83 82.7015C111.83 82.4085 111.723 82.1257 111.53 81.9071C111.337 81.6886 111.072 81.5495 110.784 81.5163L73.7408 81.4093L14.6596 81.3022H1.04644C0.758483 81.3354 0.492662 81.4745 0.299666 81.6931C0.106669 81.9116 0 82.1944 0 82.4874C0 82.7804 0.106669 83.0631 0.299666 83.2817C0.492662 83.5003 0.758483 83.6394 1.04644 83.6725L0.985932 83.6419Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.693 108.507L49.7511 108.614L108.878 108.782H122.491C122.804 108.782 123.104 108.657 123.325 108.433C123.546 108.209 123.671 107.906 123.671 107.589C123.671 107.273 123.546 106.97 123.325 106.746C123.104 106.522 122.804 106.397 122.491 106.397L85.4327 106.29L26.3062 106.121H12.693C12.3801 106.121 12.08 106.247 11.8587 106.471C11.6375 106.695 11.5132 106.998 11.5132 107.314C11.5132 107.631 11.6375 107.934 11.8587 108.158C12.08 108.381 12.3801 108.507 12.693 108.507Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90203 58.7473L45.229 58.8696L108.364 59.0532H122.809C123.097 59.02 123.363 58.8809 123.556 58.6623C123.749 58.4438 123.855 58.161 123.855 57.868C123.855 57.575 123.749 57.2923 123.556 57.0737C123.363 56.8551 123.097 56.716 122.809 56.6829L83.482 56.5606L20.3925 56.3618H5.90203C5.61407 56.3949 5.34825 56.534 5.15526 56.7526C4.96226 56.9711 4.85559 57.2539 4.85559 57.5469C4.85559 57.8399 4.96226 58.1226 5.15526 58.3412C5.34825 58.5598 5.61407 58.6989 5.90203 58.732V58.7473Z",
    fill: "#AC41D8"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5533 116.661L69.9941 116.911C67.5018 117.043 65.0551 117.278 62.5628 117.411C62.0005 117.411 61.2558 117.646 61.2558 118.189C61.2759 118.337 61.3336 118.477 61.4238 118.598C61.514 118.718 61.6339 118.815 61.7725 118.88C62.4668 119.207 63.2107 119.426 63.9761 119.526C64.3573 119.585 64.7182 119.731 65.0279 119.954C65.3376 120.176 65.5868 120.468 65.7542 120.805C65.8388 121.253 65.7793 121.716 65.5837 122.131C65.388 122.546 65.0657 122.893 64.66 123.126C63.8696 123.638 62.9694 123.97 62.027 124.098C61.0846 124.225 60.1247 124.144 59.2194 123.861C58.7232 123.718 58.2145 123.62 57.6997 123.567C57.4489 123.546 57.1964 123.578 56.96 123.662C56.7237 123.746 56.5092 123.879 56.332 124.052C56.1351 124.338 56.0215 124.671 56.0028 125.015C55.984 125.358 56.061 125.7 56.2256 126.006C56.7275 127.073 57.4787 128.013 58.4201 128.753C59.3615 129.492 60.4674 130.01 61.6509 130.266C66.59 131.545 72.2889 129.444 77 127.901",
    fill: "#C1813E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.767 78.6614L116.49 69.3312C114.732 68.3967 113.229 67.8239 111.546 66.814C110.474 66.3137 109.608 65.456 109.096 64.3872C108.965 63.7282 108.968 63.0493 109.105 62.3914C109.242 61.7335 109.51 61.1102 109.893 60.5587C110.749 58.9308 111.681 57.3331 112.688 55.7806C111.937 55.2832 111.095 54.5747 111.185 53.6703C111.275 52.766 111.937 52.5097 112.538 52.163L116.941 49.4047C118.127 48.5637 119.421 47.8892 120.789 47.4C121.555 47.1764 122.34 47.0201 123.133 46.9327C125.217 46.4912 127.379 46.5898 129.415 47.2191C130.906 47.6953 132.227 48.596 133.217 49.8116C134.098 51.1443 134.67 52.6571 134.894 54.2399C135.118 55.8226 134.986 57.4355 134.51 58.961C133.529 62.0126 131.81 64.7728 129.505 66.9949L132.812 74.2751",
    fill: "#C1813E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 54.6614C116.776 54.6614 117 54.4375 117 54.1614C117 53.8852 116.776 53.6614 116.5 53.6614C116.224 53.6614 116 53.8852 116 54.1614C116 54.4375 116.224 54.6614 116.5 54.6614Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.266 58.5324C112.625 58.772 113.031 58.9314 113.456 58.9999C113.881 59.0684 114.316 59.0444 114.731 58.9296C114.806 58.9073 114.868 58.8562 114.905 58.7874C114.942 58.7186 114.95 58.6379 114.928 58.5629C114.906 58.488 114.855 58.4249 114.787 58.3877C114.719 58.3504 114.639 58.342 114.565 58.3643C114.222 58.4597 113.863 58.4776 113.513 58.4169C113.162 58.3562 112.83 58.2182 112.538 58.0129C112.236 57.799 111.963 58.3185 112.266 58.5324Z",
    fill: "#C1813E"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.268 70.2608L109.433 76.8477C107.717 77.5247 106.188 78.6066 104.979 80.0014C103.769 81.3962 102.914 83.0627 102.485 84.8592L99.4246 97.6808C99.1211 98.9631 98.5567 100.169 97.7668 101.223C96.9768 102.277 95.9783 103.157 94.8335 103.808L72 116.385L78.1216 130.661L109.954 115.665L109.372 125.821L145 125.514V105.6C145.03 94.6194 142.293 83.8082 137.042 74.167C136.027 72.3166 134.373 70.8995 132.391 70.1806C130.408 69.4617 128.231 69.4902 126.268 70.2608Z",
    fill: "#00D38D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M126.268 70.2608L109.433 76.8477C107.717 77.5247 106.188 78.6066 104.979 80.0014C103.769 81.3962 102.914 83.0627 102.485 84.8592L99.4246 97.6808C99.1211 98.9631 98.5567 100.169 97.7668 101.223C96.9768 102.277 95.9783 103.157 94.8335 103.808L72 116.385L78.1216 130.661L109.954 115.665L109.372 125.821L145 125.514V105.6C145.03 94.6194 142.293 83.8082 137.042 74.167C136.027 72.3166 134.373 70.8995 132.391 70.1806C130.408 69.4617 128.231 69.4902 126.268 70.2608Z",
    fill: "url(#paint0_linear)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.725 65.8624C133.728 64.4735 134.716 63.1162 135.811 61.8379C136.855 60.6638 137.597 59.2429 137.971 57.7029C138.01 57.2671 138.01 56.8287 137.971 56.3929C137.971 54.4468 137.268 52.5695 135.996 51.1216C134.691 49.4872 133.003 48.2168 131.09 47.4285C129.655 46.8604 128.112 46.6236 126.738 45.8503C124.47 44.6824 122.619 42.8359 120.196 41.9521C119.634 41.7 119.015 41.6093 118.406 41.69C117.797 41.7706 117.221 42.0195 116.74 42.4098C116.383 42.797 116.142 43.2811 116.046 43.8043C115.951 44.3276 116.004 44.8679 116.2 45.3611C117.264 48.2019 123.251 48.5175 122.85 52.2895C122.694 52.9564 122.439 53.595 122.094 54.1834C121.922 54.4739 121.832 54.8068 121.832 55.1461C121.832 55.4855 121.922 55.8184 122.094 56.1089C122.275 56.2899 122.495 56.4254 122.736 56.5049C122.977 56.5843 123.232 56.6054 123.483 56.5665C124.208 56.5665 125.026 56.0457 125.751 56.3298C126.195 56.5363 126.564 56.881 126.805 57.3146C127.046 57.7482 127.147 58.2487 127.093 58.7445C127.025 59.2422 126.851 59.7187 126.585 60.141C126.318 60.5634 125.965 60.9216 125.55 61.1908C124.733 61.7343 123.803 62.0748 122.835 62.1851C122.542 62.2186 122.253 62.2766 121.971 62.3587C121.671 63.2423 121.549 64.1789 121.613 65.112C121.676 66.0451 121.924 66.9553 122.341 67.7878C122.789 68.3705 123.361 68.841 124.013 69.1637C124.665 69.4864 125.381 69.6528 126.106 69.6501C127.393 69.7225 128.676 69.4448 129.824 68.8452C131.015 68.1083 132.011 67.0841 132.725 65.8624Z",
    fill: "#2B2B2B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.372 61.2859L115.548 41.805C115.217 41.4769 115.021 41.0257 115.002 40.5478C114.982 40.0698 115.142 39.6029 115.446 39.2466C115.748 38.902 116.166 38.6935 116.612 38.6648C117.058 38.6361 117.497 38.7893 117.837 39.0925L119.305 40.4179C120.398 41.3649 121.732 41.9531 123.141 42.1093C124.55 42.2655 125.971 41.9828 127.229 41.2964L128.696 40.5412C130.588 39.507 132.751 39.1505 134.854 39.5261C136.957 39.9017 138.886 40.9888 140.347 42.6219C141.927 44.3875 142.862 46.6838 142.986 49.104C143.11 51.5243 142.414 53.9124 141.022 55.8454L137.221 61.1318C137.118 61.2819 136.985 61.4066 136.831 61.4974C136.677 61.5881 136.506 61.6427 136.331 61.6574C136.155 61.672 135.978 61.6464 135.813 61.5823C135.647 61.5181 135.497 61.417 135.372 61.2859Z",
    fill: "#EE8322"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M135.372 61.2859L115.548 41.805C115.217 41.4769 115.021 41.0257 115.002 40.5478C114.982 40.0698 115.142 39.6029 115.446 39.2466C115.748 38.902 116.166 38.6935 116.612 38.6648C117.058 38.6361 117.497 38.7893 117.837 39.0925L119.305 40.4179C120.398 41.3649 121.732 41.9531 123.141 42.1093C124.55 42.2655 125.971 41.9828 127.229 41.2964L128.696 40.5412C130.588 39.507 132.751 39.1505 134.854 39.5261C136.957 39.9017 138.886 40.9888 140.347 42.6219C141.927 44.3875 142.862 46.6838 142.986 49.104C143.11 51.5243 142.414 53.9124 141.022 55.8454L137.221 61.1318C137.118 61.2819 136.985 61.4066 136.831 61.4974C136.677 61.5881 136.506 61.6427 136.331 61.6574C136.155 61.672 135.978 61.6464 135.813 61.5823C135.647 61.5181 135.497 61.417 135.372 61.2859Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116 69.6614L120 70.5164L116.895 71.6614",
    fill: "#C1813E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.6614H33L30 37.6614",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0128 33.6614H60L58 37.6614",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.019 34.6614H115L112 37.6614",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0191 58.6614H33L30 62.6614",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0127 58.6614H60L58 62.6614",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M85 58.6614H87L85 62.6614",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0192 83.6614H33L30 87.6614",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0192 83.6614H60L57 87.6614",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0127 83.6614H87L85 87.6614",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0192 108.661H33L30 112.661",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0191 108.661H60L57 112.661",
    fill: "#AC41D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 126.926,
    y1: 135.946,
    x2: 96.8874,
    y2: 83.9648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 114.991,
    y1: 50.143,
    x2: 142.973,
    y2: 50.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE8322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllustrationConstructions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/illustration-constructions.e4afdc6eda643642277fd75b61bf602b.svg";